<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit Channel"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="editForm" :model="editForm" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Name" prop="name" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.name"
                                placeholder="Name"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Channel Code"
                            prop="channel_code"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.channel_code"
                                placeholder="Channel Code"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Delivery"
                            prop="delivery"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.delivery"
                                placeholder="Delivery"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Status" size="small" prop="status">
                            <el-radio-group v-model="editForm.status">
                                <el-radio :label="1">Open</el-radio>
                                <el-radio :label="2">Close</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            editForm: {
                name: "",
                channel_code: "",
                delivery: "",
                status: "",
            },
            roleList: [],
        };
    },
    methods: {
        channel() {
            cmofferApi.channel({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    let { data } = res;
                    this.editForm = {
                        name: data.name,
                        channel_code:data.channel_code,
                        delivery: data.delivery,
                        status: data.status,
                    };
                }
            });
        },
        save() {
            this.loading = true;
            cmofferApi
                .channel(
                    {
                        ...this.editForm,
                    },
                    "post",
                    this.tableItem.id
                )
                .then((res) => {
                    this.loading = false;
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.closeDialog();
                    this.$parent[this.funcName]();
                });
        },
        closeDialog() {
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        async initialize() {
            this.channel();
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        editVisible() {
            if (this.editVisible) {
                this.channel();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.edit {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
